/**
 * `1810` — *and only if {person, columnId} is assigned to {someone, columnValue}*.
 * Re-reads the people cell and passes iff the configured id appears in `personsAndTeams`
 * (camelCase inside `value`, never the GraphQL `persons_and_teams`). Teams match by id;
 * team **membership is not expanded** (ASSUMED, `specs/M6-A3` §11).
 */
import { z } from 'zod';
import { defineCondition } from '../block.js';
import { columnRefSchema, personIdListSchema, personsAndTeamsOf } from '../values.js';
export const personAssignedParams = z.object({
    columnId: columnRefSchema,
    /** P-278: monday's four shapes for this slot, ids out. */
    columnValue: personIdListSchema,
});
export const personAssignedCondition = defineCondition({
    id: '1810',
    kind: 'condition',
    app: 'monday',
    sentencePartial: 'and only if {person, columnId} is assigned to {someone, columnValue}',
    paramsSchema: personAssignedParams,
    requiredColumnTypes: ['people', 'person'],
    references: (params) => [
        { kind: 'column', id: params.columnId.columnId, invalid: params.columnId.invalid },
        ...params.columnValue.map((id) => ({ kind: 'user', id: String(id) })),
    ],
    async evaluate(context, params) {
        if (context.itemId === null)
            return false;
        const value = await context.services.getCellValue(context.itemId, params.columnId.columnId);
        const assigned = new Set(personsAndTeamsOf(value).map((entry) => entry.id));
        return params.columnValue.some((id) => assigned.has(id));
    },
});
//# sourceMappingURL=1810.js.map